import {
  EntityTypeSupportingPinnedFields,
  FieldDescription,
} from "@mapmycustomers/shared/types/entity";

import getFieldModelByEntityType from "@app/util/fieldModel/getByEntityType";

// Uses the field's current name, so a removed field's legacy name matches its replacement
const convertToFieldDescription =
  (entityType: EntityTypeSupportingPinnedFields, startFrom: number) =>
  (field: FieldDescription | string, index: number): FieldDescription => {
    const description =
      typeof field === "string" ? { displayOrder: startFrom + index, fieldName: field } : field;
    const currentFieldName = getFieldModelByEntityType(entityType).getByName(
      description.fieldName
    )?.name;
    return currentFieldName ? { ...description, fieldName: currentFieldName } : description;
  };

export default convertToFieldDescription;
